import type { GroupMemberApi } from 'api-typings/groups/groups';
import type { SuperuserGroupMember } from './superuser-group-members.model';

export function transformSuperuserGroupMember(
  groupPermissions: GroupMemberApi,
): SuperuserGroupMember {
  return {
    id: groupPermissions.id,
    groupId: groupPermissions.group_id,
    userId: groupPermissions.user_id,
    role: groupPermissions.role,
    created: groupPermissions.created,
  };
}
